import { axiosInstance } from "./config";


export const getAllCategories = async () => {
  const res = await axiosInstance.get('/categories');
  return res.data;
};

export const createCategory = async (data) => {
  const res = await axiosInstance.post('/categories', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const updateCategory = async (id, data) => {
  const res = await axiosInstance.post(`/categories/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const deleteCategory = async (id) => {
  const res = await axiosInstance.delete(`/categories/${id}`);
  return res.data;
};
